/**
 * Starter prompts for the assistant.
 *
 * Product copy, not mock data — which is why it lives here and not in
 * `src/mocks/`. Nothing in a render path should import from `@/mocks`.
 */
export const SUGGESTED_QUESTIONS = [
  'یه غذای سبک پیشنهاد بده',
  'برای دو نفر چی خوبه؟',
  'کم‌کالری‌ترین غذا کدومه؟',
  'با بودجه ۷۰۰ هزار تومان چی انتخاب کنم؟',
  'چه غذاهایی تخفیف دارن؟',
  'به لبنیات حساسیت دارم، چی بخورم؟',
  'یه دسر پیشنهاد بده',
  'یه نوشیدنی خنک پیشنهاد بده',
] as const;
